import React from "react";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getCookie } from "src/utils/cookieUtil";
import { baseQueryWithIntercept } from "src/utils/rtkQueryBaseQueryUtil";

const serverIp = process.env.REACT_APP_SERVER_IP;

// 1-1. initial state 객체 생성
const initialState = {};

export const scheduleAPI = createApi({
  baseQuery: baseQueryWithIntercept,
  refetchOnMountOrArgChange: true,
  //   tagTypes: ["UserVo"],
  reducerPath: "scheduleAPI",
  endpoints: (builder) => ({
    //  ========================= 견적서 상세  =========================
    scheduleList: builder.query({
      query: (date) => ({
        url: `/as/schedule/month/${date}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        providesTags: ["UserVo"],
      }),
      transformResponse: (response: any) => response.data,
      // transformResponse: (response: { data: AsVo }, meta, agr) => response.data,
    }),
    scheduleDayList: builder.query({
      query: (date) => ({
        url: `/as/schedule/day/${date}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        providesTags: ["UserVo"],
      }),
      transformResponse: (response: any) => response.data,
      // transformResponse: (response: { data: AsVo }, meta, agr) => response.data,
    }),
  }),
});

export const { useScheduleListQuery, useScheduleDayListQuery } = scheduleAPI;
